/*  MUI  */
import { ContentCopy } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { Notify } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

export const CopyInternalUseId = ({ title, value }) => {
    const { t } = useTranslation();
    return (
        <Box
            data-testid="copyInternalUseId"
            display="flex"
            flexDirection="column"
            marginTop="16px"
        >
            <Typography
                data-testid="copyInternalUseIdTitle"
                fontWeight={600}
                marginBottom="4px"
                variant="p"
            >
                {title}
            </Typography>
            <CopyToClipboard
                text={value}
                onCopy={() => Notify.s(t('Common.copied'))}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    style={{ cursor: 'pointer' }}
                >
                    <ContentCopy
                        sx={{
                            color: 'button.primary',
                            fontSize: FontSizes[1],
                            marginRight: '4px'
                        }}
                    />
                    <Box
                        data-testid="copyInternalUseIdValue"
                        sx={{
                            color: 'text.primary',
                            fontSize: FontSizes[1]
                        }}
                    >
                        {value}
                    </Box>
                </Box>
            </CopyToClipboard>
            <Typography
                data-testid="copyInternalUseIdDisclaimer"
                variant="p"
                sx={{
                    color: 'text.primary',
                    fontSize: FontSizes[0],
                    marginLeft: '16px'
                }}
            >
                {t('ClientSettings.identity_internalID_description')}
            </Typography>
        </Box>
    );
};
